export default __webpack_public_path__ + "static/get-stuff-done-m-d99dc6fcdeb5886acafd7cdbe8028fa4.webp";